import * as yup from 'yup'

export const { NEXT_PUBLIC_MAPBOX_TOKEN } = yup
  .object({ NEXT_PUBLIC_MAPBOX_TOKEN: yup.string().required() })
  .validateSync({
    NEXT_PUBLIC_MAPBOX_TOKEN: process.env.NEXT_PUBLIC_MAPBOX_TOKEN
  })
